import {
  IntegrationsPage,
  LibraryPage,
  OrganizationsPage,
  ProfilePage,
  SearchPage,
  TemplatesPage,
  UsersPage,
} from "../../views";
import { ROOT_PATH, ROUTES_CONFIG } from "@config/routes.config";

// Re-export for backward compatibility
export const RootPath = ROOT_PATH;

export const OrganizationsRoute = {
  ...ROUTES_CONFIG.ORGANIZATIONS,
  component: OrganizationsPage,
};

export const UsersRoute = {
  ...ROUTES_CONFIG.USERS,
  component: UsersPage,
};

export const IntegrationsRoute = {
  ...ROUTES_CONFIG.INTEGRATIONS,
  component: IntegrationsPage,
};

export const SearchRoute = {
  ...ROUTES_CONFIG.SEARCH,
  component: SearchPage,
};

export const ProfileRoute = {
  ...ROUTES_CONFIG.PROFILE,
  component: ProfilePage,
};

export const TemplatesRoute = {
  ...ROUTES_CONFIG.TEMPLATES,
  component: TemplatesPage,
};

export const LibraryRoute = {
  ...ROUTES_CONFIG.LIBRARY,
  component: LibraryPage,
};

export const Routes = [
  OrganizationsRoute,
  UsersRoute,
  IntegrationsRoute,
  ProfileRoute,
  SearchRoute,
  TemplatesRoute,
  LibraryRoute,
];
